/* @ngInject */

export default (
  $rootScope,
  $scope,
  $stateParams,
  $state,
  $timeout,
  $interval,
  $mdDialog,
  webpage,
  eventService,
  boardService,
  filtersService,
  workflowsService,
  ticketService,
  ticketsService,
  accountsService,
  jobsService,
  jobTypesService,
  notesService,
  labelsService,
  privilegeService,
  Ticket,
  TicketDataList,
  uiService,
  navigationService,
  partnersService,
  ACCOUNT,
  PARTNER
) => {
  /*
   * Controller Model
   * --------------------------------------------------------------------------------
   */
  $scope.Model = {
    fields: [
      { key: 'idOwner', coerceTo: 'string', class: 'qt', name: 'Deal -  - Owner' },
      { key: 'name', coerceTo: 'string', class: '', name: 'Deal -  - Name' },
      {
        key: 'values.onceOff',
        coerceTo: 'number',
        class: 'hf',
        name: 'Deal -  - Value'
      },
      { key: '', coerceTo: '', class: 'hf', name: 'Deal -  - Clients' },
      {
        key: 'organization.organization.name',
        coerceTo: 'string',
        class: '',
        name: 'Deal -  - Organization'
      },
      {
        key: 'workflow.name',
        coerceTo: 'string',
        class: '',
        name: 'Deal -  - Workflow'
      },
      { key: '', coerceTo: 'string', class: '', name: 'Deal -  - Stage' },
      {
        key: 'timeStamp',
        coerceTo: 'number',
        class: 'hf',
        name: 'Deal -  - Created on'
      },
      {
        key: '',
        coerceTo: '',
        class: 'hf',
        name: 'Deal -  - Time in stage'
      },
      { key: '', coerceTo: '', class: 'hf', name: 'Deal -  - Team members' },
      { key: '', coerceTo: '', class: 'hf', name: 'Deal -  - Referrers' }
    ],
    ordering: {
      key: 'timeStamp',
      coerceTo: 'number',
      isDescending: true
    },
    accountsData: {
      available: []
    },
    filtersData: {
      available: [],
      current: null,
      isReady: false
    },
    ticketsData: []
  };

  /*
   * Controller Public Functions: List
   * --------------------------------------------------------------------------------
   */
  $scope.listWidth = () => {
    const qt = _.filter($scope.Model.fields, (f) => f.class === 'qt').length * 125;
    const hf = _.filter($scope.Model.fields, (f) => f.class === 'hf').length * 200;
    const fl = _.filter($scope.Model.fields, (f) => f.class === '').length * 275;
    return { width: `${qt + hf + fl}px` };
  };
  $scope.openDeal = (idTicket, ticketName, idOrganization, organizationName, idWorkflow) => {
    uiService.toast({
      text: {
        p1: 'Switching to',
        p2: ticketName,
        p3: `deal in ${organizationName} organization`
      }
    });
    if (idOrganization === $rootScope.CurrentOrganization.id) {
      $state.transitionTo('deal', { id: idWorkflow, dd: idTicket });
    } else {
      $state.transitionTo('organizationSwitch');
      navigationService.organizationChange({
        idOrganization,
        url: `/deal/${idWorkflow}/${idTicket}`
      });
    }
  };
  $scope.getTimeInStage = (model) => {
    if (!model) {
      return '';
    }
    let output = 'N/A';
    const ticket = Ticket.build(model);
    if (ticket.stageHistory && ticket.stageHistory.length) {
      let duration = 0;
      for (let i = 0; i < ticket.stageHistory.length; i += 1) {
        if (ticket.stageHistory[i].idStage === ticket.idStage) {
          if (i < ticket.stageHistory.length - 1) {
            duration += moment
              .utc(ticket.stageHistory[i + 1].timeStamp, 'X')
              .diff(moment.utc(ticket.stageHistory[i].timeStamp, 'X'));
          } else {
            duration += moment.utc().diff(moment.utc(ticket.stageHistory[i].timeStamp, 'X'));
          }
        }
      }
      if (duration > 0) {
        output = moment.duration(duration).humanize();
      }
    }
    return output;
  };
  $scope.getCreatedDate = (model) => {
    if (!model) {
      return '';
    }
    const ticket = Ticket.build(model);
    return ticket.getCreatedDate($rootScope.CurrentTimeZone(), $rootScope.CurrentLocale());
  };
  $scope.getStage = (ticket) => {
    const stage = _.find(ticket?.workflow?.stages, (s) => s.id === ticket?.idStage);
    return stage ? stage.name : 'N/A';
  };
  $scope.order = (idFilter, resetOrdering) => {
    let decache = 0;
    if (resetOrdering) {
      $scope.Model.ordering = {
        key: 'timeStamp',
        coerceTo: 'number',
        isDescending: true
      };
      decache = _.uuid();
    }
    $scope.Model.ticketsData = new TicketDataList(
      idFilter,
      $scope.Model.ordering.key,
      $scope.Model.ordering.coerceTo,
      $scope.Model.ordering.isDescending,
      decache
    );
  };
  $scope.orderDesc = (desc) => {
    $scope.Model.ordering.isDescending = !!desc;
    $scope.order();
  };
  $scope.orderKey = (key) => {
    const orderKey =
      _.find($scope.Model.fields, (lf) => lf.key === key) || _.last($scope.Model.fields);
    $scope.Model.ordering.key = orderKey?.key;
    $scope.Model.ordering.coerceTo = orderKey?.coerceTo;
    $scope.order();
  };
  $scope.filterApply = (idFilter, filterName) => {
    $scope.filtersClose();
    $scope.Model.filtersData.current = { id: idFilter, name: filterName };
    $scope.order($scope.Model.filtersData.current?.id || null, true);
  };
  $scope.filtersOpen = () => {
    $timeout(() => {
      $scope.Model.filtersData.isReady = true;
    });
  };
  $scope.filtersClose = () => {
    filtersService.clearCache();
    filtersService
      .getAvailable({ type: 'ticket', isEnterprise: true, isActive: true })
      .then((filters) => {
        $scope.Model.filtersData.available = filters;
      });
    $timeout(() => {
      $scope.Model.filtersData.isReady = false;
    });
  };

  /*
   * Run Controller
   * --------------------------------------------------------------------------------
   */
  const init = () => {
    webpage.pageTitle('Loading, please wait');

    filtersService
      .getAvailable({ type: 'ticket', isEnterprise: true, isActive: true })
      .then((filters) => {
        $scope.Model.filtersData.available = filters;

        $scope.order();
        $timeout(() => {
          angular.element('.report .md-virtual-repeat-sizer').css($scope.listWidth());
          angular.element('.report .md-virtual-repeat-offsetter').css($scope.listWidth());
        }, 500);

        webpage.pageTitle('Enterprise');
      });

    accountsService
      .getInEnterprise({
        isActive: true,
        fields: ACCOUNT.FIELDS.LIST
      })
      .then((accounts) => {
        $scope.Model.accountsData.available = accounts;
      });

    partnersService
      .getAvailable({ isActive: true, fields: PARTNER.FIELDS.CHIPS })
      .then((partners) => {
        $scope.Model.partnersData.available = partners;
      });
  };

  init();
};
